import { IOperationHandler } from '@ms/items-view/lib/private/store/actions/implementOperation';
import { spSearchItemSetKeyFacet } from '../../../dataSource/Keys';
import { getItemsOperation } from '@ms/items-view/lib/private/operations/getItems';
import {
  createSingleItemOperationHandler,
  ISingleOperationPayload,
  IOperationHandlerThunkAction
} from '@ms/items-view/lib/private/addons/registerOperationHandler';
import { getFolderItemSetForItemSetKey } from '../../../operations/getFolderItemSetForItemSetKey';

export const spSearchItemSetGetItemsOperationHandler:
  IOperationHandler<typeof spSearchItemSetKeyFacet.type, typeof getItemsOperation.type> =
  createSingleItemOperationHandler({
    maxParallelOperationCount: 4
  })(getSPSearchItemSet);

function getSPSearchItemSet(
  payload: ISingleOperationPayload<typeof spSearchItemSetKeyFacet.type, typeof getItemsOperation.type>,
  options: {
    skipCache?: boolean;
  } = {}
): IOperationHandlerThunkAction {
  return getFolderItemSetForItemSetKey(spSearchItemSetKeyFacet.deserialize(payload.itemKey))(payload, options);
}
